export enum ProjectStatuses {
    Active = 'Active',
    Proposed = 'Proposed',
    Approved = 'Approved',
    Completed = 'Completed',
    Canceled = 'Canceled',
    // Discontinued = 'Discontinued' // Discontinued has been discontinued. :)
}
